// extracted by mini-css-extract-plugin
export var actions = "_t7-4";
export var item = "_t7-1";
export var price = "_t7-3";
export var quantity = "_t7-2";
export var table = "_t7-0";